export default __webpack_public_path__ + "static/media/phone_icon.1242317c.svg";